import i18n from '../ChrI18n';
import * as ObjectExtensions from '../CoreExtensions/ObjectExtensions';

class ChrCommonDateRange {
  constructor(fromDate, toDate, preset) {
    this.fromDate = fromDate || "";
    this.toDate = toDate || "";
    this.preset = preset || "";
    this.dateRangeSeparator = ChrCommonDateRange.getDateRangeSeparator();
  }

  static getDateRangeSeparator() {
    return datePickerTranslations.dateRangeSeparator;
  }

  static getComponentsFromDateString(dateString) {
    const [fromDate, toDate, preset] = dateString.split(ChrCommonDateRange.getDateRangeSeparator())
    return { fromDate, toDate, preset };
  }

  getSubmitDateRangeString() {
    if (!this.fromDate && !this.toDate)
      return "";
    const adjustedFromDate = this.fromDate || this.toDate
    const adjustedToDate = this.toDate || this.fromDate
    return [adjustedFromDate, adjustedToDate, this.preset].join(this.dateRangeSeparator);
  }

  getSubmitDateRangeStringForProfileQuestion() {
    if(!this.fromDate && !this.toDate)
      return "";
    return [this.fromDate, this.toDate, this.preset].join(this.dateRangeSeparator);
  }

  getLocaleDateRangeString(dateStringOptions, locale) {
    const fromDateObject = new Date(this.fromDate);
    const toDateObject = new Date(this.toDate);
    const currentLocale = locale || i18n.locale;

    return [fromDateObject, toDateObject].filter(dateObject => !isNaN(dateObject))
            .map(date => date.toLocaleDateString(currentLocale, dateStringOptions))
            .join(this.dateRangeSeparator);
  }
}

export default ChrCommonDateRange;
